import useLocaleText from 'components/useLocaleText'
import { agentLiterals } from '../../model/literals'
import React from 'react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import { BaseModalV3, CloseButton } from 'components/ui'
import { classNames } from '../../styles/classNames'
import theme from '../../styles/theme.module.css'
import styles from './styles.module.css'

interface IProps {
  title: string
  onClose: () => void
  children: React.ReactNode
  wide?: boolean
  settings?: boolean
  description?: string
  icon?: React.ReactNode
  footer?: React.ReactNode
  className?: string
  maxWidth?: string
}

export const AgentModal: React.FC<IProps> = ({
  title,
  onClose,
  children,
  wide,
  settings,
  description,
  icon,
  footer,
  className,
  maxWidth,
}) => {
  const labels = {
    close: useLocaleText(agentLiterals.close),
  }
  const isRtl = useSelector(isRtlSelector)

  return (
    <BaseModalV3
      isOpen
      onClose={onClose}
      closeOnOverlayClick
      closeOnEsc
      trapFocus
      contentProps={{
        className: classNames(theme.modal, settings && styles.settings, className),
        dir: isRtl ? 'rtl' : 'ltr',
        'aria-label': title,
        style: {
          borderRadius: 22,
          maxHeight: 'calc(100vh - 32px)',
          minWidth: 0,
          width: 'calc(100vw - 32px)',
          maxWidth: maxWidth || (wide ? '760px' : '480px'),
        },
      }}
      headerProps={{
        className: styles.modalHeader,
        style: { padding: undefined, background: undefined, boxShadow: 'none' },
      }}
      bodyProps={{
        className: styles.modalBody,
        style: {
          height: 'auto',
          maxHeight: footer ? 'calc(100vh - 230px)' : '70vh',
          padding: undefined,
          background: undefined,
          justifyContent: 'flex-start',
        },
      }}
      footerProps={{
        className: styles.modalFooter,
        style: { display: footer ? 'flex' : 'none', padding: undefined, background: undefined },
      }}
      header={
        <div className={styles.modalHeading}>
          <div className={styles.modalHeadingContent}>
            {icon && (
              <span className={styles.modalHeadingIcon} aria-hidden="true">
                {icon}
              </span>
            )}
            <div>
              <h2 className={styles.modalTitle}>{title}</h2>
              {description && <p className={styles.modalDescription}>{description}</p>}
            </div>
          </div>
          <CloseButton aria-label={`${labels.close}: ${title}`} onClick={onClose} flexShrink={0} />
        </div>
      }
      body={<>{children}</>}
      footer={<>{footer}</>}
    />
  )
}
